// Section for import npm components -----------------------------------------------------------------------------------
import React, { useState } from 'react';

// Material UI ( mui )  components
import Box from '@mui/material/Box';

// Section for import custom components --------------------------------------------------------------------------------
import CustomTabPanel from '@components/MansionNavigation/CustomTabPanel';
import PrefecturesListContent from '@components/MansionNavigation/PrefecturesListContent';
import CustomTabs from '@components/MansionNavigation/CustomTabs';

// Section for import custom types -------------------------------------------------------------------------------------
import PrefecturesData from '@/types/components/MansionNavigation/PrefecturesData';
import RegionsData from '@/types/components/MansionNavigation/RegionsData';

interface PrefecturesSelectorProps {
  prefecturesData: PrefecturesData;
  regionData: RegionsData;
  modePrefSelect: string;
}

export default function PrefecturesSelector({
  prefecturesData,
  modePrefSelect,
  regionData,
}: PrefecturesSelectorProps): React.JSX.Element {
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number): void => {
    setTabValue(newValue);
  };

  return (
    <Box className="max-md:pb-2">
      <CustomTabs tabValue={tabValue} handleChange={handleChange} />
      <CustomTabPanel value={tabValue} index={0}>
        <PrefecturesListContent
          prefecturesData={prefecturesData}
          modePrefSelect={modePrefSelect}
          regionData={regionData}
        />
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={1}>
        <PrefecturesListContent prefecturesData={prefecturesData} modePrefSelect="lines" regionData={regionData} />
      </CustomTabPanel>
    </Box>
  );
}
